import { useQuery } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { Response } from '../services/backendService/types';

const useApiResponses = (gameId: string, roundId: string, filterDismissed?: boolean) => {
  const { data: responses, isFetching } = useQuery({
    queryKey: ['responses', roundId, gameId],

    queryFn: async () => {
      const res = await BackendService.instance.game.retrievePublicResponses({
        roundId,
        gameId,
      });
      if (res && filterDismissed) {
        return res.filter(r => !r.dismissed);
      }
      return res;
    },

    staleTime: 1000 * 60 * 60
  });

  return {
    responses: responses ? responses : [],
    isFetching,
  };
};

export default useApiResponses;
